export const ButtonUpdate = (props) => {
    const { entity, id } = props;
    let href = `/admin/entity/update/${entity}/${id}`;
    return (
        <div className="button-update">
            <a className="button" href={href}>Update</a>
        </div>
    )
}